// extracted by mini-css-extract-plugin
export var dropdownButton = "_2h-0";
export var fullWidthDropdownButton = "_2h-1";
export var icon = "_2h-3";
export var iconPlaceholder = "_2h-2";
export var menuItemRow = "_2h-8";
export var separator = "_2h-c";
export var shortcutContainer = "_2h-7";
export var shortcutIconLg = "_2h-6";
export var shortcutIconMd = "_2h-5";
export var shortcutIconSm = "_2h-4";
export var submenuChevron = "_2h-b";
export var submenuDropdown = "_2h-9";
export var submenuTriggerRow = "_2h-a";